import { ENGLISH, SPANISH } from "../../context/languaje/types";

export const questionsList = {
  [SPANISH]: [
    {
      title: "¿Puedo estar seguro mientras usan mi cuenta?",
      description: `Cada cuenta está vinculada a un correo personal, sin acceso a este, no se puede modificar ningún dato de la cuenta como contraseña o mismo correo, nosotros jamás te pediremos ese correo, por lo que es imposible que sea robada.`,
    },
    {
      title: "¿Puedo jugar con mi cuenta durante el proceso de boosteo?",
      description: `¡Sí! puedes jugar Partidas Normales sin problema, solo asegúrate de que el booster no esté usándola en ese momento lo cual podría retrasar el trabajo. Recuerda que NO podes jugar Partidas Clasificatorias durante el proceso.`,
    },
    {
      title: "¿Cuáles son los métodos de pago?",
      description: `Aceptamos la moneda de tu país, puedes pagar con cualquier moneda, contamos con métodos de pago en efectivo y con tarjeta de crédito.`,
    },
    {
      title: "Me equivoqué al poner los datos de la cuenta ¿Qué debería hacer?",
      description: `Deberias ponerte en contacto a traves de cualquiera de nuestras redes ¡solucionaremos el problema al momento!`,
    },
    {
      title: "¿Los boosters verán mis chats, botín o usarán esencia o rp?",
      description: `Los chats no serán abiertos ni respondidos, a menos que el cliente lo pida, el servicio es confidencial, los boosters no usarán RP, ni esencia ni romperán el botín. "Ponte en contacto con nosotros a través del soporte en vivo o Facebook, y vamos a solucionar el problema tan pronto como sea posible."`,
    },
    {
      title: "¿Puedo espectar las partidas mientras suben mi cuenta?",
      description: `¡Si! Puedes hacerlo desde alguna página que se lo permita o desde alguna cuenta secundaria o algún amigo.`,
    },
    {
      title: "¿Puedo fijar los horarios en que los que juegan en mi cuenta?",
      description: `¡Si! Los horarios son fijados por el cliente para la comodidad de su tiempo y su cuenta!.`,
    },
  ],

  [ENGLISH]: [
    {
      title: "Can I be safe while they use my account?",
      description: `Each account is linked to a personal email, without access to it, you cannot modify any account data such as password or email, we will never ask you for that email, so it is impossible for it to be stolen.`,
    },
    {
      title: "Can I play with my account during the boosting process?",
      description: `Yeah! You can play Normal Games without problem, just make sure that the booster is not using it at that moment which could delay the work. Remember that you CANNOT play Ranked Matches during the process.`,
    },
    {
      title: "What are the payment methods?",
      description: `We accept the currency of your country, you can pay with any currency, we have cash and credit card payment methods.`,
    },
    {
      title:
        "I made a mistake when entering the account information. What should I do?",
      description: `You should get in touch through any of our networks, we will solve the problem immediately!`,
    },
    {
      title: "Will boosters see my chats, loot, or use essence or rp?",
      description: `Chats will not be opened or answered unless the client requests it, the service is confidential, boosters will not use RP, essence or break loot. "Contact us via live support or Facebook, and we will fix the issue as soon as possible."`,
    },
    {
      title: "Can I watch the games while my account is raised?",
      description: `Yeah! You can do it from a page that allows it or from a secondary account or a friend.`,
    },
    {
      title: "Can I set the times that people play on my account?",
      description: `Yeah! The schedules are set by the client for the convenience of their time and their account!`,
    },
  ],
};

export const mainDescription = {
  [SPANISH]: `No te preocupes, puedes leer nuestra sección de "preguntas frecuentes" ¡así no te quedas con ninguna duda!`,
  [ENGLISH]: `No te preocupes, puedes leer nuestra sección de "preguntas frecuentes" ¡así no te quedas con ninguna duda!`,
};
